

<template>
  <div>
       
        <!-- 内容 -->
        <div class="main">
            <div class="banner" v-if="banner.length">
                <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide v-for="(v,i) in banner" :key="i" >
                    <div class="img pr" style="padding-top: 40%;">
                        <img class="pa" style="top: 0; left: 0; width: 100%; height: 100%;"  :src="v.image" :onerror="errorImg" />
                    </div>
                </swiper-slide>
                <div class="swiper-pagination swiper-pagination1" slot="pagination"></div>
                </swiper>
            </div>

            <div class="home-bk1">
                <div class="wrap2 fiex indextit1">
                    <div class="f-34  mag-r-20 " :class="{'cur':type==1}" @click="type=1">{{ lanuage("10000", "Now Showing") }} </div>
                    <div class="f-34" :class="{'cur':type==2}"  @click="type=2">{{ lanuage("10003", "Coming Soon") }}</div>
                </div>
                <div class="bank20"></div>
                <div class="box wrap2 pr" v-if="type==1">
                    <template v-if="Now_Showing.length">
                    <div class="swiper-button-prev prev1"></div>
                    <div class="swiper-button-next next1"></div>
                    <swiper ref="mySwiper" :options="swiperOptions2">
                        <swiper-slide v-for="(v,i) in Now_Showing" :key="i">
                            <dl class="add">
                                <dt>
                                    <div class="w">
                                        <div class="f-24  t1 mag-b-5">
                                            <span  class="mag-r-10">{{v.name}}</span>
                                            <i class="f-14 ">
                                                <div class="fiex">
                                                    <span>{{v.score | BB}}</span>
                                                </div>
                                            </i>
                                        </div>
                                        <div class="f-16 mag-b-10 t2" v-if="v.dimensionalList">
                                            <span>{{v.dimensionalList[0]}}</span>
                                            <template v-if="v.dimensionalList[1]">
                                                <i></i>
                                                <span>{{v.dimensionalList[1]}}</span>
                                            </template>
                                        </div>
                                        <div class="fiex t3">
                                            <div class="fiex1"><a :href="'#/tickets/choose?id='+ v.id" class="bon com-bon">Buy Tickets</a></div>
                                            <div v-if="v.filmLevel">
                                                <img v-if="v.filmLevel=='18'" src="../assets/images/t1.png" />
                                                <img v-if="v.filmLevel=='U'" src="../assets/images/t2.png" />
                                                <img v-if="v.filmLevel=='P13'" src="../assets/images/t3.png"  />
                                            </div>
                                        </div>
                                    </div>
                                </dt>
                                <dd><a :href="'#/film/detail?id='+ v.id"><img :src="v.poster" /></a></dd>
                            </dl>
                        </swiper-slide>
                    </swiper>
                    </template>
                    <template v-else="">
                        <div class="null center fiex" style="height: 390px; justify-content: center;">
                        <div>
                            <img style="width: 100px; height: 100px;" src="/static/404.png" />
                            <!-- <p class="mag-t-20">No Hot Showing</p> -->
                        </div>
                        </div>
                    </template>
                </div>

                <div class="box wrap2 pr" v-if="type==2">
                    <template v-if="Coming_Soon.length">
                        <div class="swiper-button-prev prev2"></div>
                        <div class="swiper-button-next next2"></div>
                        <swiper ref="mySwiper" :options="swiperOptions3">
                            <swiper-slide v-for="(v,i) in Coming_Soon" :key="i">
                                <div class="box">
                                    <!-- <div class="t f-16" v-if='v.title'>{{v.title}}</div>
                                    <div class="ta f-16" v-else=''>&nbsp;</div> -->
                                    <dl>
                                        <dt>
                                            <div class="w">
                                                <div class="f-24 fiex t1">
                                                    <span class="mag-r-10">{{v.name}}</span>
                                                    <i class="f-14 ">
                                                        <div class="fiex">
                                                            <span>{{v.score | BB}}</span>
                                                        </div>
                                                    </i>
                                                </div>
                                                <div class="f-16 mag-b-10 t2">
                                                    <span>{{v.director}}</span>
                                                    <!-- <i></i>
                                                    <span>Action</span> -->
                                                </div>
                                                <div class="fiex t3">
                                                    <div class="fiex1 fiex">
                                                        <a :href="'#/film/detail?type=2&id='+ v.id" class="bon bon2 fiex">
                                                            <span class="mag-r-10">Trailer</span>
                                                            <img src="../assets/images/icon8.png" />
                                                        </a>
                                                    </div>
                                                    <div v-if="v.filmLevel">
                                                        <img v-if="v.filmLevel=='18'" src="../assets/images/t1.png" />
                                                        <img v-if="v.filmLevel=='U'" src="../assets/images/t2.png" />
                                                        <img v-if="v.filmLevel=='P13'" src="../assets/images/t3.png"  />
                                                    </div>
                                                </div>
                                            </div>
                                        </dt>
                                        <dd><a :href="'#/film/detail?type=2&id='+ v.id"><img :src="v.poster" /></a></dd>
                                    </dl>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </template>
                    <template v-else="">
                        <div class="null center fiex" style="height: 390px; justify-content: center;">
                           <div>
                            <img style="width: 100px; height: 100px;" src="/static/404.png" />
                            <!-- <p class="mag-t-20">No Coming Soon</p> -->
                           </div>
                        </div>
                    </template>
                </div>

            </div>

     
            <div class="banner2" v-if="banner2.length">
                <div class="box">
                    <swiper ref="mySwiper" :options="swiperOptions4">
                        <swiper-slide v-for="(v,i) in banner2" :key="i">
                            <div class="img pr" style="padding-top: 30%;">
                                <img class="pa" style="top: 0; left: 0; width: 100%; height: 100%;"  :src="v.pcHomeLogo "/>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination swiper-pagination4" slot="pagination"></div>
                    </swiper>
                </div>
            </div>

            <!-- 首页食品组件 -->
            <SellGoods v-if="goodsshow"></SellGoods>

        </div>
        <!-- 内容 -->

        
     
    

  </div>

</template>

<script>
    import {
    getHitFilm,
    getUpcomingFilm,
    getDistribution,
    homenewslist
    } from "@/api/home/home";
    import { getHeartBeat ,getCinemaInfoList } from "@/api/api";

    import SellGoods from "./sell/shop.vue"
    import { mapState, mapActions } from "vuex";
	export default {
        components: {
    SellGoods
     },
    name: 'app',
		data(){
			return{
                l: 100,
                drawer:true,
                type:1,
                keySearch:'',
                goodsshow:false,
                swiperOptions: {
                    autoplay:true,
                    pagination: {
                        el: '.swiper-pagination1',
                        clickable :true,
                    },
                },
                swiperOptions2: {
                    slidesPerView : 4,  
                    navigation: {
                        nextEl: '.next1',
                        prevEl: '.prev1',
                    },
                },
                swiperOptions3: {
                    slidesPerView : 4,  
                    navigation: {
                        nextEl: '.next2',
                        prevEl: '.prev2',
                    },
                },
                swiperOptions4: {
                    pagination: {
                        el: '.swiper-pagination4',
                        clickable :true,
                    },
                },
                buyclass:'',
                banner:[],
                banner2:[],
                Now_Showing:[],  
                Coming_Soon:[],
                Food_Beverage:[],
                isFirstEnter:false
            }			
        },
        computed: {
            isFollow () {
                console.log(1)
                return this.$store.state.cityList.cinemaInfo.cinemaCode;　　//需要监听的数据
            }
        },
        watch: {
        isFollow (newVal, oldVal) {
            console.log(oldVal);
            console.log(newVal);
            //do something
        }
        },
        activated() {
            // console.log('activated');
            // if(!this.isFirstEnter){
            //     this.init();
            // }
            
            // this.isFirstEnter = false;
            },
		mounted(){
            
            this.init();
            // if(this.isFirstEnter){
            //     this.init();
            // }
            // 正在热映 联调'11050611'
            // this.getFilm();
            // // 即将上映
            // this.getUpcomingFilm();
            // // 获取轮播图
            // this.getBanner();

            // //咨询banner
            // this.newslist();
		},
		methods: {
            ...mapActions("cityList", ["setCinemaInfo","setCityInfo","setCityCode"]),
            init(){
                console.log(123123)
                this.goodsshow=false;
                if(this.$store.state.cityList.cinemaInfo.cinemaCode!=''){
                    this.getFilm();
                    // 即将上映
                    this.getUpcomingFilm();
                    // 获取轮播图
                    this.getBanner();

                    //咨询banner
                    this.newslist();
                    setTimeout(() => {
                        this.goodsshow=true;
                    }, 0);
                }else{
                    this.mov();
                }
                
            },
            async mov(){
                let res = await getCinemaInfoList()
                    res.data.forEach((v,i) => {
                    v.cinemas.forEach((vv,ii) => {
                    if(i==0 && ii==0){
                        this.setCinemaInfo({
                        cinemaCode: vv.unifiedCode,
                        cinemaName: vv.name,
                        cinemaAdress: vv.address,
                        cinemaId: vv.id,
                        lat: vv.lat,
                        lng: vv.lng
                        })
                       this.setCityInfo(v.cityInfo.chName)
                       this.setCityCode(v.cityId);
                        //window.location.reload();
                        this.init()
                    }
                    });
                });
            },
              // 正在热映
            getFilm() {
            console.log("llll",this.l)
            getHitFilm({ l: this.l})
                .then(res => {
                if (res.code === 200 || res.code === 1020001) {
                    this.Now_Showing = res.data || [];
                } else {
                    this.$toast(res.msg);
                }
                })
                .catch(err => console.error(err));
            },
            // 获取轮播图
            getBanner() {
                getDistribution({
                    t:7,
                    apiVersion: 1,
                    viewPosition: 21,
                    source:"formal"//数据源 formal=正式数据 / test=测试数据 / fake=假数据 为空则返回正式数据
                })
                .then(res => {
                if ((res.data && res.code == "200") || res.code === 1020001) {
                    this.banner = res.data  || [];
                }
                })
                .catch(e => {
                console.error(e);
                });
            },
            // 即将上映接口方法封装
            getUpcomingFilm() {
                getUpcomingFilm({
                    l: this.l
                }).then(res => {
                    if (res.code === 200) {
                    // 对数据进行一些处理
                    let a=[]
                    res.data.forEach((v,i) => {
                        v.comingFilmEntityList.forEach((vv,ii) =>{
                            a.push(vv);
                        })
                    });
                    console.log(a);
                    this.Coming_Soon = a || [];
                    }
                    // else {
                    //   this.$toast(res.m)
                    // }
                });
            },
            newslist(){
                homenewslist({pageNum: 1,pageSize:5,isApp:0,isPcHomeLogo:1}).then(res => {
                    if (res.code === 200) {
                    // 对数据进行一些处理
                        this.banner2 = res.data.records  || [];
                    }
                });
            },
            handleChange(value) {//计步器
                console.log(value);
            },
			onSearch(){//关键字搜索

            },
            addfoots(){
             
            }
		}
	};
	</script>




// WEBPACK FOOTER //
// src/views/index.vue